exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".residential-button-disabled.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff !important;\n  background-color: #01b1af !important;\n  border-color: #01b1af !important;\n}\n.residential-button-disabled.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  color: #01b1af !important;\n  background-color: #dde1e3 !important; /* Disabled background color */\n  border-color: #dde1e3 !important; /* Disabled text color */\n}\n", ""]);

// exports
